import styled from 'styled-components';

const HomeGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
`;

const HomeBanner = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  height: 200px;
  font-size: 26px;
  font-weight: bold;
`;

const HomeContent = styled.div``;

export { HomeGrid, HomeContent, HomeBanner };



// WEBPACK FOOTER //
// ./src/components/UI/HomeUI.tsx